import type { KeyboardEvent as ReactKeyboardEvent } from 'react'
import { memo } from 'react'
import { HourlyInputCell } from 'ui/components/HourlyDataTable/HourlyInputCell'
import type { Direction, MouseEventLike } from './BidInputTable.types'
import { getCellKey } from './helpers/BidInputTable.helpers'

type BidInputCellProps = {
  direction: Direction
  hourIndex: number
  positionId: string
  tagId: string
  displayValue: string
  isSelected: boolean
  isInvalid: boolean
  isGroupStart: boolean
  ariaLabel: string
  onValueChange: (value: string) => void
  onKeyDown: (ev: ReactKeyboardEvent) => void
  onMouseDown: (ev: MouseEventLike) => void
  onMouseOver: () => void
  registerRef: (element: HTMLInputElement | null) => void
}

export const BidInputCell = memo(function BidInputCell({
  direction,
  hourIndex,
  positionId,
  tagId,
  displayValue,
  isSelected,
  isInvalid,
  isGroupStart,
  ariaLabel,
  onValueChange,
  onKeyDown,
  onMouseDown,
  onMouseOver,
  registerRef,
}: BidInputCellProps) {
  // Derive the opaque cell key that the generic behavior hooks use
  const cellKey = getCellKey(hourIndex, positionId, tagId, direction)

  return (
    <HourlyInputCell
      cellKey={cellKey}
      value={displayValue}
      isSelected={isSelected}
      isInvalid={isInvalid}
      isGroupStart={isGroupStart}
      isGroupEnd={!isGroupStart}
      ariaLabel={ariaLabel}
      tdDataAttributes={{
        'data-bid-hour-index': String(hourIndex),
        'data-bid-position-id': positionId,
        'data-bid-tag-id': tagId,
        'data-bid-direction': direction,
      }}
      onValueChange={onValueChange}
      onFocus={() => {}}
      onBlur={() => {}}
      onKeyDown={onKeyDown}
      onMouseDown={onMouseDown}
      onMouseOver={onMouseOver}
      registerRef={registerRef}
    />
  )
})
